import { getQstOptions } from "./createInputs";

let brAdded = false;
export const makeBrAddedFalse = () => {
  brAdded = false;
};
export const handleQuestionsDisplay = (questions, mapKeyed, type, termPlan, termPlanLogic) => {
  questions.forEach((question) => {
    if (type === "parent") {
      question.display = "block";
      if (!termPlan && question.customerResponse) {
        question.addHrBelow = true;
      }
    } else if (type === "primary") {
      const parentId = question.qstPrtId;
      if (parentId && parentId !== "null") {
        const parentQuestion = mapKeyed[parentId];
        if (
          (parentQuestion.customerResponse === getQstOptions(parentQuestion.qstOpt)[0] ||
            (!termPlan && parentQuestion.customerResponse)) &&
          (parentQuestion.customerResponse !== getQstOptions(parentQuestion.qstOpt)[1]
            || (termPlan && termPlanLogic == "Y" && parentQuestion.customerResponse))
        ) {
          question.display = "block";
        } else {
          question.display = "none";
          delete question.customerResponse
        }
      } else {
        question.display = "block";
        if (!termPlan && !brAdded) {
          brAdded = true;
          question.addBrAbove = true;
        }
      }
    } else if (type === "secondary") {
      const primaryId = question.qstPrtId;
      const primaryQuestion = mapKeyed[primaryId];
      const parentId = primaryQuestion.qstPrtId

      if (parentId && parentId !== "null") {
        const parentQuestion = mapKeyed[parentId];
        if (
          (parentQuestion.customerResponse === getQstOptions(parentQuestion.qstOpt)[0] &&
            primaryQuestion.customerResponse === getQstOptions(primaryQuestion.qstOpt)[0]) ||
          (!termPlan &&
            parentQuestion.customerResponse &&
            primaryQuestion.customerResponse === getQstOptions(primaryQuestion.qstOpt)[0])
        ) {
          question.display = "block";

        } else {
          delete question.customerResponse
          question.display = "none";
        }
      } else {
        if (primaryQuestion && primaryQuestion.customerResponse === getQstOptions(primaryQuestion.qstOpt)[0]) {
          question.display = "block";
          if (!termPlan && !brAdded) {
            brAdded = true;
            question.addBrAbove = true;
          }
        } else {
          question.display = "none";
          delete question.customerResponse
        }
      }
    } else if (type === "secondary2") {
      const primaryId = question.qstPrtId;
      const primaryQuestion = mapKeyed[primaryId];
      const parentId = primaryQuestion.qstPrtId

      if (parentId && parentId !== "null") {
        const parentQuestion = mapKeyed[parentId];
        if (
          (parentQuestion.customerResponse === getQstOptions(parentQuestion.qstOpt)[0] &&
            primaryQuestion.customerResponse === getQstOptions(primaryQuestion.qstOpt)[0]) ||
          (!termPlan &&
            parentQuestion.customerResponse &&
            primaryQuestion.customerResponse === getQstOptions(primaryQuestion.qstOpt)[0])
        ) {
          question.display = "block";

        } else {
          question.display = "none";
          delete question.customerResponse
        }
      } else {
        if (primaryQuestion && primaryQuestion.customerResponse === getQstOptions(primaryQuestion.qstOpt)[0]) {
          question.display = "block";
          if (!termPlan && !brAdded) {
            brAdded = true;
            question.addBrAbove = true;
          }
        } else {
          question.display = "none";
          delete question.customerResponse
        }
      }
    } else {
      const secondaryId = question.qstPrtId;
      const secondaryQuestion = mapKeyed[secondaryId];
      const primaryId = secondaryQuestion.qstPrtId;
      const primaryQuestion = mapKeyed[primaryId];
      const parentId = primaryQuestion.qstPrtId;

      if (parentId && parentId !== "null") {
        const parentQuestion = mapKeyed[parentId];
        if (
          (parentQuestion.customerResponse === getQstOptions(parentQuestion.qstOpt)[0] &&
            primaryQuestion.customerResponse === getQstOptions(primaryQuestion.qstOpt)[0] &&
            secondaryQuestion.customerResponse === getQstOptions(secondaryQuestion.qstOpt)[0]) ||
          (
            parentQuestion.customerResponse &&
            primaryQuestion.customerResponse &&
            secondaryQuestion.customerResponse === getQstOptions(secondaryQuestion.qstOpt)[0])
        ) {
          console.log("TERTIARY TRUE :: ", {parentQuestion, primaryQuestion, secondaryQuestion, opts: getQstOptions(question.qstOpt)})
          question.display = "block";
        } else {
          question.display = "none";
          delete question.customerResponse
        }
      } else {
        if (secondaryQuestion.customerResponse === getQstOptions(secondaryQuestion.qstOpt)[0] && primaryQuestion.customerResponse === getQstOptions(primaryQuestion.qstOpt)[0]) {
          question.display = "block";
        } else {
          question.display = "none";
          delete question.customerResponse
        }
      }
    }
  });
  return questions;
};
